import moment from 'moment-timezone';
import { IST, format_ist } from '../../../util_components/care_request/care_request_rules';

// Pure helpers for the Status History and Reschedule Logs pop-ups; Care reads every time in IST.

export const ist_datetime = format_ist;

export const ist_date = (iso) => (iso ? moment(iso).tz(IST).format('DD MMM YYYY') : '--');

export const ist_time = (iso) => (iso ? `${moment(iso).tz(IST).format('hh:mm A')} IST` : '--');

// sub_status may arrive as a SET string, an array or a JSON-encoded array.
export function format_sub_status(value) {
  if (!value) return '--';
  if (Array.isArray(value)) return value.join(', ') || '--';
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed.join(', ') || '--';
  } catch (e) {
    // not JSON: a plain SET string
  }
  return String(value);
}

// The history table's status enum lacks several session statuses, which MySQL stores as ''; such rows say nothing.
export const visible_status_history = (rows) =>
  (rows || []).filter((row) => !!row?.status || format_sub_status(row?.sub_status) !== '--');
